"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _ArrowLeftLine = _interopRequireDefault(require("@rsuite/icon-font/lib/direction/ArrowLeftLine"));

// Generated by script, don't edit it please.
var ArrowLeftLine = (0, _createSvgIcon["default"])({
  as: _ArrowLeftLine["default"],
  ariaLabel: 'arrow left line',
  category: 'direction',
  displayName: 'ArrowLeftLine'
});
var _default = ArrowLeftLine;
exports["default"] = _default;
module.exports = exports.default;